// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"682d479d","400":"75250030","473":"75250030","778":"64c48f4d"}[chunkId] + ".chunk.css";
};